"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dateFns = require("date-fns");
var _lock = _interopRequireDefault(require("cccisd-icons/svg/lock4"));
var _play = _interopRequireDefault(require("cccisd-icons/svg/play4"));
var _spinner = _interopRequireDefault(require("cccisd-icons/svg/spinner11"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _cccisdColorPicker = require("cccisd-color-picker");
var _style = _interopRequireDefault(require("../style.css"));
var _color = _interopRequireDefault(require("color"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var translate = {
  en: {
    lessonText: 'LESSON',
    play: 'Play',
    quickReview: 'QUICK REVIEW',
    replay: 'Replay',
    resume: 'Resume'
  },
  es: {
    lessonText: 'LECCIÓN',
    play: 'Empezar',
    quickReview: 'REVISIÓN RÁPIDA',
    replay: 'Repetirse',
    resume: 'Reanudar'
  }
};
var LessonCard = function LessonCard(_ref) {
  var baseColor = _ref.baseColor,
    buttonColors = _ref.buttonColors,
    getLessonHighlight = _ref.getLessonHighlight,
    item = _ref.item,
    language = _ref.language,
    lessonNum = _ref.lessonNum,
    _ref$lessons = _ref.lessons,
    lessons = _ref$lessons === void 0 ? [] : _ref$lessons,
    progressBubbleColors = _ref.progressBubbleColors,
    showLastVisited = _ref.showLastVisited,
    showLessonNum = _ref.showLessonNum,
    showProgressBubbleNum = _ref.showProgressBubbleNum;
  language = Object.keys(translate).includes(language) ? language : 'en';
  var action = getAction(item);
  var hasNextLesson = lessons.length >= lessonNum + 2;
  var lessonAreaRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(109),
    _useState2 = _slicedToArray(_useState, 2),
    lessonAreaHeight = _useState2[0],
    setLessonAreaHeight = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hovering = _useState4[0],
    setHovering = _useState4[1];
  var baseColorHex = (0, _cccisdColorPicker.getColor)(baseColor);
  (0, _react.useEffect)(function () {
    if (lessonAreaRef.current && lessonAreaRef.current.offsetHeight !== lessonAreaHeight) {
      setLessonAreaHeight(lessonAreaRef.current.offsetHeight);
    }
    function handleResize() {
      if (lessonAreaRef.current && lessonAreaRef.current.offsetHeight !== lessonAreaHeight) {
        setLessonAreaHeight(lessonAreaRef.current.offsetHeight);
      }
    }
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  });
  function getAction(lesson) {
    switch (true) {
      case lesson.isCompleted:
        return 'replay';
      case lesson.isResume:
        return 'resume';
      default:
        return 'play';
    }
  }
  function renderActionButton() {
    var playIcon = item.isAllowed ? /*#__PURE__*/_react["default"].createElement(_play["default"], null) : /*#__PURE__*/_react["default"].createElement(_lock["default"], null);
    var buttonData = {
      play: {
        className: 'btn-info',
        icon: playIcon,
        color: (0, _cccisdColorPicker.getColor)(buttonColors.start)
      },
      resume: {
        className: 'btn-primary',
        icon: null,
        color: (0, _cccisdColorPicker.getColor)(buttonColors.resume)
      },
      replay: {
        className: _style["default"].grayButton,
        icon: /*#__PURE__*/_react["default"].createElement(_spinner["default"], null),
        color: (0, _cccisdColorPicker.getColor)(buttonColors.replay)
      }
    };
    var buttonText = translate[language][action];
    var buttonInfo = buttonData[action];

    // presenter mode always starts user fresh back at beginning,
    // so always use text that matches behavior
    if (item.isPresenterMode) {
      buttonText = translate[language].play;
      buttonInfo = buttonData.play;
    }
    var buttonColor = (0, _color["default"])(buttonInfo.color);
    var buttonContrast = buttonColor.contrast((0, _color["default"])('#ffffff'));
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: (0, _classnames["default"])('btn btn-block', !buttonInfo.color && buttonInfo.className, !item.isAllowed && 'disabled'),
      onClick: item.setCurrent,
      style: buttonInfo.color ? {
        color: buttonContrast >= 2.99 ? '#fff' : '#333',
        backgroundColor: hovering && item.isAllowed ? buttonColor.darken(0.05) : buttonInfo.color,
        borderColor: buttonColor.lighten(0.25)
      } : {},
      onMouseEnter: function onMouseEnter() {
        setHovering(true);
      },
      onMouseLeave: function onMouseLeave() {
        setHovering(false);
      }
    }, buttonInfo.icon && /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].actionIcon
    }, buttonInfo.icon, "\xA0"), buttonText);
  }
  function renderQuickReview() {
    if (!item.quickReview) {
      return /*#__PURE__*/_react["default"].createElement("div", null);
    }

    // setting can be { "quickReviewTitle": "" } to turn it completely off
    var quickReviewTitle = 'quickReviewTitle' in item ? item.quickReviewTitle : translate[language].quickReview;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].quickReviewWrapper
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].quickReviewTitle
    }, quickReviewTitle), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: item.quickReview
    }));
  }
  function renderLessonMain() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].lessonCard,
      ref: lessonAreaRef
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].lessonInnerWrapper
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].lessonText,
      style: {
        color: "".concat(baseColorHex)
      }
    }, getLessonHighlight(item), showLessonNum && "".concat(translate[language].lessonText, " ").concat(lessonNum + 1)), /*#__PURE__*/_react["default"].createElement("p", null, typeof item.title === 'string' ? /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: item.title
    }) : /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: item.title.content
    })), renderActionButton(), showLastVisited && item.lastVisited && /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].lastVisited
    }, "Last visited ", (0, _dateFns.format)(new Date(item.lastVisited), 'MM/dd/yyyy'))), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_style["default"].quickReviewDivider, !!item.quickReview && _style["default"].quickReviewDividerColor)
    }), renderQuickReview());
  }
  function renderLessonStatus() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_style["default"].lessonStatusOuter, _style["default"]["lesson".concat(action)]),
      style: progressBubbleColors[action] ? {
        background: (0, _cccisdColorPicker.getColor)(progressBubbleColors[action])
      } : {}
    }, action === 'resume' && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_style["default"].lessonplay, _style["default"].lessonStatusOuterPartial)
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].lessonStatusInner
    }, showProgressBubbleNum ? lessonNum + 1 : null)), hasNextLesson && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_style["default"].lessonStatusBeam, _style["default"]["lesson".concat(action)]),
      style: _objectSpread({
        height: "".concat(lessonAreaHeight, "px")
      }, progressBubbleColors[action] ? {
        background: (0, _cccisdColorPicker.getColor)(progressBubbleColors[action])
      } : {})
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, renderLessonStatus(), renderLessonMain());
};
var _default = LessonCard;
exports["default"] = _default;